import api from 'services/technical-visit/finish-technical-visit'

export const handleGet = async (id: string) => {
  let res = await api.get(id)

  return res?.data?.data
}
